export class DateComparison {

    public static readonly MIN_VALUE = '0000-01-01';
    public static readonly MAX_VALUE = '9999-12-31';


    constructor() {
    }

    public static checkForOverlappingDates(aStartDate: string | null | undefined, aEndDate: string | null | undefined, bStartDate: string | null | undefined, bEndDate: string | null | undefined): boolean {
        if((!aStartDate && !aEndDate) ||
            (!bStartDate && !bEndDate)) {
            return false;
        }

        if(aStartDate === bEndDate || aStartDate === bEndDate) {
            return true;
        }

        aStartDate = !aStartDate ? DateComparison.MIN_VALUE : aStartDate;
        aEndDate = !aEndDate ? DateComparison.MAX_VALUE : aEndDate;
        bStartDate = !bStartDate ? DateComparison.MIN_VALUE : bStartDate;
        bEndDate = !bEndDate ? DateComparison.MAX_VALUE : bEndDate;

        if((aStartDate <= bEndDate && aEndDate >= bStartDate) || (aStartDate <= bEndDate && bStartDate <= aEndDate)) {
            return true;
        }

        return false;
    }

    public static checkForContainingDates(aStartDate: string | null | undefined, aEndDate: string | null | undefined, bStartDate: string | null | undefined, bEndDate: string | null | undefined): boolean {
        // Assume the A dates make up the Range that the B dates need to fall into.
        if(aStartDate === null && aEndDate === null) { return true; }

        aStartDate = !aStartDate ? DateComparison.MIN_VALUE : aStartDate;
        aEndDate = !aEndDate ? DateComparison.MAX_VALUE : aEndDate;
        bStartDate = !bStartDate ? DateComparison.MIN_VALUE : bStartDate;
        bEndDate = !bEndDate ? DateComparison.MAX_VALUE : bEndDate;

        //Ensure the B dates are within the A date ranges
        if(bStartDate >= aStartDate && bStartDate <= aEndDate &&
            bEndDate >= aStartDate && bEndDate <= aEndDate) {
            return true;
        }

        return false;
    }

    protected getMinValue(): string {
        return DateComparison.MIN_VALUE;
    }

    protected getMaxValue(): string {
        return DateComparison.MAX_VALUE;
    }

}
